/**
 * Secret special codes (snippets/special-code-state.liquid) stay hidden until
 * the shopper has the code. Liquid can't see a code entered through a
 * /discount/ link or at checkout until it discounts a cart line, so this copies
 * the cart's entered codes into the hidden cart attribute _special_codes, which
 * Liquid can read. When that would reveal something on the current page (it
 * carries a hidden secret product's marker), the page reloads once.
 */
(function () {
  var ATTRIBUTE = '_special_codes';
  var RELOADED_KEY = 'special-code-sync:reloaded';

  function enteredCodes(cart) {
    var codes = (cart.discount_codes || [])
      .map(function (entry) {
        return String(entry.code || '').trim().toUpperCase();
      })
      .filter(Boolean)
      .sort();
    return codes.filter(function (code, i) {
      return codes.indexOf(code) === i;
    });
  }

  // Once per set of codes per session, so a code the page can't reveal
  // anyway (say the attribute didn't stick) can never cause a reload loop.
  function reloadOnce(codes) {
    try {
      if (sessionStorage.getItem(RELOADED_KEY) === codes) return;
      sessionStorage.setItem(RELOADED_KEY, codes);
    } catch (e) {
      return;
    }
    window.location.reload();
  }

  fetch('/cart.js', { credentials: 'same-origin' })
    .then(function (res) {
      return res.json();
    })
    .then(function (cart) {
      var codes = enteredCodes(cart);
      var joined = codes.join(',');
      var stored = (cart.attributes && cart.attributes[ATTRIBUTE]) || '';
      if (joined === stored) return;

      var previous = stored ? stored.split(',') : [];
      var added = codes.some(function (code) {
        return previous.indexOf(code) === -1;
      });

      // Shopify merges attributes, so the cart's other attributes stay; an
      // empty value removes this one.
      var attributes = {};
      attributes[ATTRIBUTE] = joined;
      return fetch('/cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: attributes })
      }).then(function (res) {
        // The marker: an empty <template> in the product forms, an attribute
        // on collection cards.
        if (res.ok && added && document.querySelector('[data-secret-code-hidden]')) {
          reloadOnce(joined);
        }
      });
    })
    .catch(function (error) {
      console.error('[special-code-sync]', error);
    });
})();
